import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
const Home = () => import(/* webpackChunkName: "Home" */ "./views/Home.vue");

export default new Router({
  mode: "history",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/paintings",
      name: "paintings",
      component: Home
    },
    {
      path: "/drawings",
      name: "drawings",
      component: Home
    },
    {
      path: "/other",
      name: "other",
      component: Home
    },
    {
      path: "/editorial",
      name: "editorial",
      component: Home
    },
    {
      path: "/curatorial",
      name: "curatorial",
      component: Home
    },
    {
      path: "/list",
      name: "list",
      component: Home
    },
    {
      path: "/info",
      name: "info",
      component: Home
    },
    {
      path: "*",
      redirect: "/"
    }
  ]
});
